import { useDispatch, useSelector } from 'react-redux';

import {
    changeGeoLocation,
    clearGeoLocation,
    setGeoLocationLoading,
} from '../store/geo-location/geo-location.slice';
import { ILocation } from '../api/types';
import { useCallback } from 'react';
import axios from 'axios';
import { selectGeoLocation } from '../store/geo-location/geo-location.selector';

export const useGeoLocation = (): {
    setGeoLocation: (location: ILocation) => void;
    clearLocation: () => void;
    userLocation: ILocation;
    loading: boolean;
    fetchUserGeolocation: () => Promise<void>;
} => {
    const dispatch = useDispatch();
    const { entry: userLocation, loading } = useSelector(selectGeoLocation);

    const setGeoLocation = (location: ILocation) => {
        dispatch(changeGeoLocation(location));
    };
    const clearLocation = () => {
        dispatch(clearGeoLocation());
    };

    const setLocation = useCallback((location: ILocation) => {
        localStorage.setItem('geoLocation', JSON.stringify(location));
        setGeoLocation(location);
    }, []);

    const fetchUserGeolocation = useCallback(async () => {
        const geoSuccess = (position: GeolocationPosition) => {
            setLocation({
                lng: position.coords.longitude,
                lat: position.coords.latitude,
            });
        };

        const geoError = async () => {
            try {
                //? todo is free api_key ?, should be proxied on be side
                const response = await axios.get(
                    'https://ipgeolocation.abstractapi.com/v1/?api_key=b6e10c9c746345238e76736de3275c01'
                );
                setLocation({
                    lng: response.data.longitude,
                    lat: response.data.latitude,
                });
            } catch (error) {
                console.error('Something went wrong getting Geolocation from API!', error);
                dispatch(setGeoLocationLoading(false));
            }
        };

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: Infinity,
        });
    }, [setLocation]);

    return {
        setGeoLocation,
        clearLocation,
        userLocation,
        loading,
        fetchUserGeolocation,
    };
};
